import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './language/zh'
import zhs from './language/zhs'
import en from './language/en'

Vue.use(VueI18n)
function welcomeMessage() {
    let language = window.navigator.language || this.defaultLanguage;
    switch (language) {
        case 'zh-Hant':
        case 'zh-TW':
            language = 'zhs';
            break;
    }
    return language;
}
const locale = welcomeMessage() || 'zhs'
const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'zhs',
    messages: {
        en,
        zh,
        zhs
    }
})

export default i18n
